/**
 * 画面サイズが変わるたびvh取得
 */
function setHeight() {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
  let h_h = $(".js_head").outerHeight();
  let product_media = $(".js_product_media").outerHeight();
  document.documentElement.style.setProperty("--head-h", `${h_h}px`);
  //let nav_h = document.getElementById("js_btns").offsetHeight;
  //document.documentElement.style.setProperty("--nav-h", `${nav_h}px`);
  if (product_media > 0) {
    document.documentElement.style.setProperty("--media-h", `${product_media}px`);
  }
}
setHeight();
//ブラウザのサイズが変更された時・画面の向きを変えた時にvh再計算
window.addEventListener("resize", setHeight);

const mobileHeaderMediaQuery = window.matchMedia("(max-width: 860px)");
let lastScrollY = window.scrollY;
function toggleHeaderScrollClass() {
  const currentScrollY = window.scrollY;
  const head = $(".js_head");

  head.toggleClass("is_sc", currentScrollY >= 500);

  if (mobileHeaderMediaQuery.matches) {
    if (currentScrollY > lastScrollY && currentScrollY > 0) {
      head.addClass("is_hidden");
    } else if (currentScrollY < lastScrollY) {
      head.removeClass("is_hidden");
    }
  } else {
    head.removeClass("is_hidden");
  }

  lastScrollY = currentScrollY;
}
toggleHeaderScrollClass();
window.addEventListener("scroll", toggleHeaderScrollClass, { passive: true });
window.addEventListener("resize", toggleHeaderScrollClass);

$(document).on("click", ".js_gnvBtn", function () {
  let nav = $(".js_gnav");
  let head = $(".bl_header");
  let $this = $(this);
  $this.toggleClass("is_active");
  head.toggleClass("is_active");
  nav.fadeToggle(500);
});
$(document).on("click", ".js_parent", function () {
  let $this = $(this);
  $this.toggleClass("is_active");
  $this.next().slideToggle(500);
});
$(document).on("click", ".js_tab", function () {
  let $this = $(this);
  let btns = $(this).parents(".js_tabBtns");
  let btns_data = btns.data("tabs");
  let target = $this.data("tab");
  let box = btns.next(".js_tabBox");
  if (btns_data != undefined) {
    box = $("body").find('*[data-tabitems="' + btns_data + '"]');
    btns.find(".js_tab").removeClass("is_active");
    box.each(function (index, element) {
      console.log($(this));
      $(this).find(".js_tabItem").removeClass("is_show");
      $(this)
        .find('.js_tabItem[data-tabItem="' + target + '"]')
        .addClass("is_show");
    });
    $this.addClass("is_active");
  } else {
    btns.find(".js_tab").removeClass("is_active");
    box.find(".js_tabItem").removeClass("is_show");
    $this.addClass("is_active");
    box.find('.js_tabItem[data-tabItem="' + target + '"]').addClass("is_show");
  }
});
//modal
var {
  OverlayScrollbars,
  ScrollbarsHidingPlugin, //プラグイン
  SizeObserverPlugin, //プラグイン
  ClickScrollPlugin, //プラグイン
} = OverlayScrollbarsGlobal;
function setupProgressHandle(osInstance) {
  const elements = osInstance.elements();

  const scrollEl = elements.viewport;
  const handle = elements.scrollbarHorizontal?.handle;

  if (!scrollEl || !handle) return;

  const update = () => {
    const max = scrollEl.scrollWidth - scrollEl.clientWidth;
    const progress = max <= 0 ? 1 : scrollEl.scrollLeft / max;
    handle.style.width = (progress * 100).toFixed(2) + "%";
  };

  scrollEl.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", update);
  update();
}

if ($(".js-modal-button-target").length > 0) {
  var target = $(".js-modal-button-target").data("modal");
  $(".js-modal-button-target").modaal({
    content_source: target,
    type: "inline",
    after_open: function (modal) {
      const el = document.querySelector(".modaal-wrapper .js_modal_scroll");
      if (!el) return;

      const osInstance = OverlayScrollbars(el, {
        overflowBehavior: {
          x: "scroll",
          y: "hidden",
        },
        scrollbars: {
          autoHide: "never", // インジケーターなので常時表示
        },
      });

      setupProgressHandle(osInstance);

      // 画像ロード後にも再計算
      el.querySelectorAll("img").forEach((img) => {
        if (img.complete) return;
        img.addEventListener(
          "load",
          () => {
            osInstance.update();
            setupProgressHandle(osInstance);
          },
          { once: true },
        );
      });
    },
  });
}

if ($(".bl_mvSlide_slide .swiper-container").length == 1) {
  swipeOption = {
    loop: true,
    autoplay: {
      delay: 1000,
    },
    slidesPerView: 1,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    speed: 3000,
    pagination: {
      el: ".bl_mvSlide_nav",
    },
  };
} else {
  swipeOption = {
    loop: false, //ループしない
    autoplay: false, //オートプレイしない
  };
}
new Swiper("#mainSlider .swiper-container", swipeOption); //ここはデフォのswiper宣言

const prodctMv = new Swiper(".bl_prodctMv_slide", {
  slidesPerView: 1,
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  speed: 6000,
  pagination: {
    el: ".bl_mvSlide_nav",
  },
});

//商品スライダー
const breakpoint = 860;

let bl_slide = null;
function initR630Slide() {
  bl_slide = new Swiper(".bl_slide", {
    slidesPerView: 1,
    fadeEffect: {
      crossFade: true,
    },
    speed: 500,
    pagination: {
      el: ".bl_slide_nav",
      clickable: true,
    },
  });
}

$(window).on("load resize", function () {
  if (bl_slide == null) {
    initR630Slide();
  }
  if ($(window).outerWidth() < breakpoint) {
    bl_slide.destroy(false, true);
    bl_slide = null;
  }
});

let product_slide_thumb = null;
let product_slide = null;

function initMainSwiper() {
  if (product_slide) return;
  product_slide = new Swiper(".bl_product_media", {
    slidesPerView: 1,
    grabCursor: false,
    navigation: {
      nextEl: ".bl_product_media_btn__next",
      prevEl: ".bl_product_media_btn__prev",
    },
  });
}

function bindThumbTap() {
  $(".bl_product_thumb .swiper-slide").each(function (i) {
    $(this).attr("data-thumb-index", i);
    if (i == 0) {
      $(this).addClass("is-active");
    }
  });
  $(".bl_product_thumb")
    .off("click")
    .on("click", ".swiper-slide", function (e) {
      e.preventDefault();
      const idx = Number($(this).attr("data-thumb-index"));
      if (Number.isNaN(idx)) return;
      product_slide.slideTo(idx);
      $(".bl_product_thumb .swiper-slide").removeClass("is-active");
      $(this).addClass("is-active");
    });

  // メインがスワイプされたときもサムネのactiveを同期（任意）
  product_slide.off("slideChange");
  product_slide.on("slideChange", function () {
    const idx = product_slide.realIndex ?? product_slide.activeIndex;
    $(".bl_product_thumb .swiper-slide").removeClass("is-active");
    $(`.bl_product_thumb .swiper-slide[data-thumb-index="${idx}"]`).addClass("is-active");
  });
}

$(function () {
  initMainSwiper();
  bindThumbTap();
});

//movie
var ytPlayer = null;
var ytReady = false;
var currentVideoId = "";
var playerRequested = false;

// YouTube IFrame Player API 読み込み
(function () {
  var tag = document.createElement("script");
  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName("script")[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
})();

// API 読み込み完了時に呼ばれるグローバル関数
function onYouTubeIframeAPIReady() {
  ytReady = true;
}

$(function () {
  var $modal = $("#js_videoModal");

  function openVideoModal(videoId) {
    currentVideoId = videoId;
    $modal.addClass("is_open");
    // 初回のみ player 生成
    if (ytReady && !ytPlayer && !playerRequested) {
      playerRequested = true;

      ytPlayer = new YT.Player("js_youtubePlayer", {
        videoId: currentVideoId,
        playerVars: {
          autoplay: 1,
          rel: 0,
          playsinline: 1,
        },
        events: {
          onReady: function (event) {
            event.target.playVideo();
          },
        },
      });

      return;
    }

    // 既存 player がある場合は動画差し替えして再生
    if (ytPlayer && typeof ytPlayer.loadVideoById === "function") {
      ytPlayer.loadVideoById(currentVideoId);
      return;
    }

    // API未読込なら少し待って再実行
    var waitCount = 0;
    var timer = setInterval(function () {
      waitCount++;

      if (ytReady) {
        clearInterval(timer);

        if (!ytPlayer) {
          ytPlayer = new YT.Player("js_youtubePlayer", {
            videoId: currentVideoId,
            playerVars: {
              autoplay: 1,
              rel: 0,
              playsinline: 1,
            },
            events: {
              onReady: function (event) {
                event.target.playVideo();
              },
            },
          });
        } else if (typeof ytPlayer.loadVideoById === "function") {
          ytPlayer.loadVideoById(currentVideoId);
        }
      }

      if (waitCount > 100) {
        clearInterval(timer);
      }
    }, 100);
  }

  function closeVideoModal() {
    $modal.removeClass("is_open");

    if (ytPlayer && typeof ytPlayer.stopVideo === "function") {
      ytPlayer.stopVideo();
    }
  }

  $(document).on("click", ".js_video", function (e) {
    e.preventDefault();
    var videoId = $(this).data("video-id");
    openVideoModal(videoId);
  });

  $(document).on("click", ".js_videoClose", function () {
    closeVideoModal();
  });

  $(document).on("keydown", function (e) {
    if (e.key === "Escape") {
      closeVideoModal();
    }
  });
});
